import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import styles from './detail-hero.module.css';

interface DetailDescriptionProps {
    text: string;
}

/** Cut to two lines on mobile, with a "Read more" to show the rest. */
export function DetailDescription({ text }: DetailDescriptionProps) {
    const ref = useRef<HTMLParagraphElement>(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isClamped, setIsClamped] = useState(false);

    useEffect(() => {
        const element = ref.current;
        if (!element || isExpanded) return undefined;

        const observer = new ResizeObserver(() => setIsClamped(element.scrollHeight > element.clientHeight + 1));
        observer.observe(element);
        return () => observer.disconnect();
    }, [isExpanded]);

    return (
        <div className={styles['detail-hero__description-container']}>
            <p ref={ref} className={classNames(styles['detail-hero__description'], { [styles['detail-hero__description--expanded']]: isExpanded })}>
                {text}
            </p>
            {(isClamped || isExpanded) && (
                <button type="button" className={styles['detail-hero__read-more']} onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? 'Read less' : 'Read more'}
                </button>
            )}
        </div>
    );
}

export default DetailDescription;
